import { useState, useRef } from "react";
import { Card } from "react-bootstrap";
import { toast } from "react-toastify";
import api from "../../../services/api";
import { useLoading } from "../../../hooks/useLoading"
import { ImportAlertModal } from "./ModalImportAlert";
import { ImportProcessResult } from "./ImportProcessResult";
import { ImportActionButtons } from "./ImportActionButtons";

export function ImportTab() {
  const [uploadedFile, setUploadedFile] = useState(null);
  const [processResult, setProcessResult] = useState(null);
  const [exportingBatchId, setExportingBatchId] = useState(null);
  const [isImportAlertModalOpen, setIsImportAlertModalOpen] = useState(false);

  const fileInputRef = useRef(null);
  const loading = useLoading()

  function handleFileChange(event) {
    setUploadedFile(null)
    setProcessResult(null)

    const file = event.target.files[0];

    if (!file) return;

    setUploadedFile(file)
  };

  function handleRemoveFile() {
    setUploadedFile(null);
    setProcessResult(null)

    if (fileInputRef.current) {
      fileInputRef.current.value = null; // Reseta o input de arquivo
    }
  };

  async function handleUploadfile() {
    if (!uploadedFile) {
      toast.warning("Selecione um arquivo para processar.")
    }

    const formData = new FormData();
    formData.append("file", uploadedFile);

    try {
      loading.setLoading(true)
      setProcessResult(null)

      const response = await api.post("/produto/v1/precomonitoradoimport", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      const resultData = {
        ...response.data,
        processDate: new Date().toLocaleString("pt-BR")
      }

      setProcessResult(resultData)

      if (resultData.alert > 0 || resultData.no_processed > 0 || resultData.error > 0) {
        setIsImportAlertModalOpen(true)
      }

      loading.setLoading(false)
    } catch (err) {
      loading.setLoading(false)
      setProcessResult(null)

      if (err.response?.data?.message) {
        toast.error(err.response.data.message);
      } else {
        toast.error("Falha no envio do arquivo.")
      }
    }
  }

  async function handleExportBatchDetails(batchId) {
    try {
      setExportingBatchId(batchId);
      const response = await api.get("produto/v1/exporta_lote_importacao/", {
        params: {
          id_lote: batchId
        },
        responseType: "blob"
      })

      // Access headers.content-disposition to get the file name
      const contentDisposition = response.headers["content-disposition"]

      let fileName = `log_importacao_lote_${batchId}.xlsx`;

      if (contentDisposition) {
        const fileNameMatch = contentDisposition.match(/filename="(.+)"/)

        if (fileNameMatch && fileNameMatch.length > 1) {
          fileName = fileNameMatch[1];
        }
      }

      const url = window.URL.createObjectURL(new Blob([response.data]))

      const link = document.createElement("a")
      link.href = url
      link.setAttribute("download", fileName)

      document.body.appendChild(link)
      link.click()
      link.remove()

      window.URL.revokeObjectURL(url)

      setExportingBatchId(null)
    } catch (error) {
      setExportingBatchId(null)
      if (error.response?.data?.message) {
        toast.error(error.response.data.message)
      } else {
        toast.error("Falha ao exportar os detalhes do lote.")
      }
    }
  }

  return (
    <>
      <Card>
        <Card.Header>
          <Card.Title className="w-100 fw-bold fs-4">
            <h4>Importação de Preços</h4>
          </Card.Title>
          <Card.Subtitle className="mb-2 text-muted">
            Utilize esta funcionalidade para importação de preços em massa.
          </Card.Subtitle>
          <Card.Text>
            Para começar, faça o download da planilha modelo. Após preenchê-la com os novos preços, retorne a esta página e faça o upload do arquivo para que as alterações sejam processadas.
          </Card.Text>
        </Card.Header>

        <Card.Body>
          <ImportActionButtons
            fileInputRef={fileInputRef}
            handleFileChange={handleFileChange}
            uploadedFile={uploadedFile}
            handleRemoveFile={handleRemoveFile}
            handleUploadfile={handleUploadfile}
            loading={loading}
          />
        </Card.Body>

        <Card.Body className="border-top border-secondary-subtle">
          <ImportProcessResult
            processResult={processResult}
            loading={loading}
            exportingBatchId={exportingBatchId}
            handleExportBatchDetails={handleExportBatchDetails}
          />
        </Card.Body>
      </Card>

      {isImportAlertModalOpen && (
        <ImportAlertModal
          processResult={processResult}
          isImportAlertModalOpen={isImportAlertModalOpen}
          setIsImportAlertModalOpen={setIsImportAlertModalOpen}
          handleExportBatchDetails={handleExportBatchDetails}
          exportingBatchId={exportingBatchId}
        />
      )}

    </>
  )
}
